

import {Component, Vue} from "vue-property-decorator";
import NavigationBar from "@/components/layout/navigation/NavigationBar.vue";
import NavigationDrawer from "@/components/layout/navigation/NavigationDrawer.vue";

@Component({
  components: {NavigationDrawer, NavigationBar},
})
export default class Navigation extends Vue {

}
